import type { BalanceApiContact, BalanceSummaryRow } from '@features/balanceLedger/config/balanceSideConfig'
// TODO(AUDIT-255): cross-view import until balance ledger utils are extracted into the feature.
import { minorToMajor } from '@views/suppliersBalance/utils/moneyUtils'

// Kept on the customer side even though the debtor summary rows currently match the creditor ones:
// the statement entries the two sides normalize do diverge (invoice vs bill document number).
export const normalizeDebtorBalanceContact = (contact: BalanceApiContact): BalanceSummaryRow => ({
  id: contact.contactId,
  auxiliaryAccountNo: contact.auxiliaryAccountNo ?? null,
  name: contact.contactName,
  balance: minorToMajor(contact.balance.value),
  lastPeriod: contact.comparisonBalance ? minorToMajor(contact.comparisonBalance.value) : 0,
  variance: contact.variance ? minorToMajor(contact.variance.value) : 0,
  variancePercentage: contact.variancePercent ?? null,
})
